import * as types from './actionTypes';
import {apiRequest, apiPost} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import {ROLE_SuperUser} from '../constants';

export function loadBdmsSuccess(bdms){
  return {type: types.LOAD_BDMS_SUCCESS, bdms};
}

export function saveBdmClientSuccess(bdmClient){
  return {type: types.SAVE_BDM_CLIENT_SUCCESS, bdmClient};
}

export function deleteBdmClientSuccess(bdmClient){
  return {type: types.DELETE_BDM_CLIENT_SUCCESS, bdmClient};
}

export function loadBdms() {
  return function (dispatch, getState) {
    let user = getState().account.user;    
    if(!user){
      return;
    }

    dispatch(loadBdmsSuccess({loaded: false, items: []}));
    return apiRequest(`/api/bdms`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching BDMS, error: ${x.error ? x.error : x.data.Message}`);
          dispatch(loadBdmsSuccess({loaded: true, items: []}));
        } else {
          dispatch(loadBdmsSuccess({loaded: true, items: Array.from(x.data)}));
        }
      });
  };
}

export function saveBdmClient(bdm, client) {
  return function (dispatch) {
    toastr.success('Saving client to BDM');
    return apiPost(`/api/bdms/${bdm.id}/assignClient/${client.id}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error assigning client to BDM, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(saveBdmClientSuccess({bdm, client}));
        }
      });
  };
}


export function deleteBdmClient(bdm, client) {
  return function (dispatch) {
    toastr.success('Removing client from BDM');
    return apiPost(`/api/bdms/${bdm.id}/unassignClient/${client.id}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error unassigning client from BDM, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          dispatch(deleteBdmClientSuccess({bdm, client}));
        }
      });
  };
}
